/**
 * Utility to get Firebase ID token
 * Can be called from browser console
 */

import { auth } from '@/firebase/config';

export async function getFirebaseToken(): Promise<string | null> {
  try {
    if (!auth) {
      console.error('Firebase auth not initialized');
      return null;
    }
    
    const user = auth.currentUser;
    if (!user) {
      console.error('No user logged in');
      return null;
    }
    
    const token = await user.getIdToken();
    return token;
  } catch (error) {
    console.error('Error getting token:', error);
    return null;
  }
}

// Expose to window for console access
if (typeof window !== 'undefined') {
  (window as any).getFirebaseToken = getFirebaseToken;
}

